import { styles } from './Evaluations.styles';

export const EvaluationsLoading = () => (
	<>
		<header className={styles.topbar}>
			<div className="h-md w-[120px] animate-pulse rounded bg-grey-25" />
		</header>
		<main className={styles.content}>
			<div className="h-[28px] w-[200px] animate-pulse rounded bg-grey-25" />
			<div className="flex flex-col gap-xs">
				{['a', 'b', 'c', 'd'].map((k) => (
					<div key={`row-${k}`} className="h-[56px] animate-pulse rounded bg-grey-25" />
				))}
			</div>
		</main>
	</>
);
